import genericApi from './genericApi';

import GhaModel from '../models/Gha';
import ApiResponse from '../models/ApiResponse';
import GhaDock from '../models/GhaDock';

const ghaReqHandler = {

  getGhaWithAirline: (id: number): Promise<ApiResponse<GhaModel>> => {

    return genericApi.get(`gha/${id}?airlines=true`);
  },
  getGhaTime: (id: number, seconds: number): Promise<ApiResponse<{date: string, time: string}>> => {

    return genericApi.get(`gha/time/${id}/${seconds}`);
  },
  getGhaDocks: (ghaID: number): Promise<ApiResponse<Array<GhaDock>>> => {

    return genericApi.get(`gha/${ghaID}/docks`);
  },
  getGhaInfo: (id: number, secretKey: string): Promise<ApiResponse<GhaModel>> => {
 
    const keyParam: string = secretKey ? `&key=${secretKey}` : '';

    return genericApi.get(`gha/${id}?airlines=false${keyParam}`);
  },
  getGHAs: (): Promise<ApiResponse<Array<{id: number, name: string}>>> => {

    return genericApi.get('gha');
  },
  getGhaName: (ghaId: number) : Promise<ApiResponse<{ ghaName: string }>> => {
 
    return genericApi.get(`gha/name/${ghaId}`)
  }

};

export default ghaReqHandler;